import React from 'react';
import { DropdownList } from 'react-widgets';
import { Customer } from '../../../../core';
import { AssigneeAccountType } from './AssignUsers';
import api from '../../../../api';
import SalesPersonsAutoCompleteInput from '../../../../components/form-group/sales-persons-auto-complete-input';
import AutoCompleteInput from '../../../../components/form-group/auto-complete-input';

interface ChangeModalProps {
  isVisible: boolean;
  title: string;
  placeholder: string;
  selectedPerson: Customer | undefined;
  setSelectedPerson: (person: Customer) => void;
  changeReasons: any[];
  reason: any;
  setReason: (reason: any) => void;
  selectReason: boolean;
  setSelectReason: (select: boolean) => void;
  closeModal: () => void;
  onSubmit: (person: Customer | undefined, reason: any) => void;
  showroomId?: string;
  cityIds?: string[];
  companyId?: string;
  isLoading?: boolean;
  includeIds?: (string | undefined)[];
  hideBlocked?: boolean;
  apiUrl?: string;
  useSpecialInput?: 'salesPerson' | 'regular' | 'assignee';
  accountType?: AssigneeAccountType;
}

const PersonnelChangeModal: React.FC<ChangeModalProps> = ({
  isVisible,
  title,
  placeholder,
  selectedPerson,
  setSelectedPerson,
  changeReasons,
  reason,
  setReason,
  selectReason,
  setSelectReason,
  closeModal,
  onSubmit,
  showroomId,
  cityIds = [],
  companyId,
  isLoading = false,
  includeIds,
  hideBlocked = true,
  apiUrl,
  useSpecialInput = 'regular',
  accountType
}) => {
  if (!isVisible) return null;

  const getDataLoader = (query?: string) => {
    switch (useSpecialInput) {
      case 'salesPerson':
        return api.customer.searchSalesPerson(
          { query, hideBlocked, ...(cityIds.length ? { cityIds } : {}) },
          "lead-assignees",
        );
      case 'assignee':
        return api.customer.searchAssignee({
          query,
          hideBlocked,
          accountType
        });
      default:
        if (title === 'Support Executive') {
          return api.customer.searchCrmAgents(
            { query, hideBlocked, ...(cityIds.length ? { cityIds } : {}) },
            "lead-assignees",
            companyId,
          );
        } else {
          return api.customer.searchStaff({
            query,
            hideBlocked,
          });
        }
    }
  };

  const renderInput = () => {
    if (useSpecialInput === 'salesPerson') {
      return (
        <SalesPersonsAutoCompleteInput
          loadingText={isLoading ? "Assigning ..." : ""}
          defaultValue={selectedPerson}
          placeholder={placeholder}
          onChange={(person: Customer) => setSelectedPerson(person)}
          apiUrl={apiUrl || "api/user/sales-persons"}
          valueField={"name"}
          showroomId={showroomId}
          dataLoader={getDataLoader}
          disabled={isLoading}
          hideBlocked={hideBlocked}
          includeIds={includeIds}
        />
      );
    } else {
      return (
        <AutoCompleteInput
          defaultValue={selectedPerson}
          placeholder={placeholder}
          onChange={(person: Customer) => setSelectedPerson(person)}
          apiUrl={apiUrl || "api/user/crm-agents"}
          valueField={"name"}
          showroomId={showroomId}
          hideBlocked={hideBlocked}
          dataLoader={getDataLoader}
        />
      );
    }
  };

  return (
    <>
      <div
        className="modal fade show in"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
          <div className="modal-content rounded-0">
            <div className="modal-body ">
              <div className="container">
                <div className="form-group mb-3">
                  <label
                    htmlFor=""
                    className="font-sm font-weight-semibold"
                  >
                    {title}
                  </label>
                  {renderInput()}
                </div>
                <div className="form-group mb-3">
                  <label
                    htmlFor=""
                    className="font-sm font-weight-semibold"
                  >
                    Change Reason
                  </label>
                  <DropdownList
                    textField={"reason"}
                    valueField={"_id"}
                    placeholder={"Select reason for change"}
                    data={changeReasons}
                    onChange={(e) => {
                      setReason(e);
                      setSelectReason(false);
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-auto mr-auto">
                    <button
                      type="button"
                      className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-auto">
                    <button
                      type="button"
                      disabled={selectReason}
                      className="btn btn-primary py-2 font-weight-semibold font-normal px-4"
                      onClick={() => onSubmit(selectedPerson, reason)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default PersonnelChangeModal;